import { render, staticRenderFns } from "./TaskNote.vue?vue&type=template&id=34876270&scoped=true&"
import script from "./TaskNote.vue?vue&type=script&lang=js&"
export * from "./TaskNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34876270",
  null
  
)

export default component.exports